import * as z$1 from "zod/v4";
//#region src/schemas/daemon/computer-care.ts
const OPENMELD_COMPUTER_CARE_HEADER = "x-openmeld-computer-care";
const executionHostObservationSchema = z$1.strictObject({
	hostInstanceId: z$1.uuid(),
	observedAtMs: z$1.number().int().nonnegative().nullable(),
	responsive: z$1.boolean(),
	admission: z$1.enum(["open", "draining"]).nullable(),
	activeCount: z$1.number().int().nonnegative().nullable(),
	pendingCount: z$1.number().int().nonnegative().nullable(),
	unacknowledgedResultCount: z$1.number().int().nonnegative().nullable(),
	startupReplayPending: z$1.boolean().nullable()
});
const computerCareObservationSchema = z$1.strictObject({
	observedAtMs: z$1.number().int().nonnegative(),
	connection: z$1.enum([
		"connected",
		"unavailable",
		"unknown"
	]),
	supervisor: z$1.enum(["responding", "unknown"]),
	lastHeartbeatAtMs: z$1.number().int().nonnegative().nullable(),
	executionHost: executionHostObservationSchema.nullable()
});
//#endregion
export { OPENMELD_COMPUTER_CARE_HEADER, computerCareObservationSchema, executionHostObservationSchema };

//# sourceMappingURL=computer-care.js.map